<script setup lang="ts">
    import { FrontpageItem, FrontpageItemGroup } from '@/shared/helpers/api';
    import { useRouter } from 'vue-router';

    const router = useRouter();

    const props = defineProps<{
        item: FrontpageItem;
        group: FrontpageItemGroup;
    }>();

    function itemClick() {
        const destination = props.item.href;
        if (/^http/.test(destination)) {
            window.open(destination);
        } else {
            router.push(destination);
        }
    }

</script>

<template>
    <div
        class="item-container"
        tabindex="0"
        @click="itemClick()"
        @keydown.enter="itemClick()">
        <div :class="['item-icon-container', props.group.class]">
            <b-icon :icon="props.item.icon" />
        </div>
        <div>{{ props.item.label }}</div>
    </div>
</template>

<style scoped>
.item-container {
    display: flex;
    justify-content:last baseline;
    align-items: center;
    gap: 1rem;
    margin-bottom: 1rem;
    font-size: 110%;
    cursor: pointer;
}
.item-container:hover {
    font-weight: bold;
    background-color: var(--eq-bg-highlight);
}
.item-icon-container {
    background-color: var(--eq-autumn-storm-3);
    width: 3rem;
    height: 3rem;
    border-radius: 0.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
}
.fpig-1 {
    background-color: var(--eq-sand-and-summer-6);
    color: var(--eq-sand-and-summer-2);
}
.fpig-2 {
    background-color: var(--eq-additional-3);
    color: var(--eq-north-sea-3);
}
.fpig-3 {
    background-color: var(--eq-norwegian-woods-5);
    color: var(--eq-norwegian-woods-1);
}
.fpig-fav {
    background-color: var(--eq-midnight-sun-2);
    color: var(--eq-text-secondary);
}
</style>
